import { useRef, useCallback } from "react";

/**
 * usePlatformPortalTrigger — retorna um `onClick` que abre o portal do
 * Platform Admin (Super Admin) após 3 cliques em ≤2s no mesmo elemento.
 *
 * Usa `window.location.assign` (recarga completa) para ser 100% confiável
 * independentemente do contexto de router. Reset automático após 2s.
 *
 * Uso (ex.: no "Clean Manager USA"):
 *   const trigger = usePlatformPortalTrigger();
 *   <div onClick={trigger}>Clean Manager USA</div>
 */
export function usePlatformPortalTrigger() {
  const stateRef = useRef({ count: 0, timer: null });

  return useCallback((e) => {
    if (e?.stopPropagation) e.stopPropagation();
    const s = stateRef.current;
    s.count += 1;
    if (s.timer) clearTimeout(s.timer);
    if (s.count >= 3) {
      s.count = 0;
      if (typeof window !== "undefined") {
        window.location.assign("/platform/login");
      }
      return;
    }
    s.timer = setTimeout(() => {
      s.count = 0;
    }, 2000);
  }, []);
}
